import { ManagementApiService } from 'src/app/services';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import jwt_decode from 'jwt-decode';
import { map, take } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class AdminGuradGuard implements CanActivate {
    decodedData: any;
    constructor(
        private managementApiService: ManagementApiService,
        private router: Router
    ) {}
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        let token = localStorage.getItem('msal.accessToken');
        this.decodedData = jwt_decode(token);

        //Added new guard according to Check Super Admin for Ice Database.
        return this.managementApiService.getFullUserDetail(this.decodedData.oid).pipe(
            take(1),
            map((response) => {
                // Joint Assured menu option = (response.license.instanceTypeIndex & 1) == 1
                // Project Assured menu option = (response.license.instanceTypeIndex & 2) == 2
                //Competency Assured + Joint Assured would be 5
                //Competency Assured + Joint Assured + Project Assured = 7
                //#15391 for reference, we are checking for 1,3,5,7 as these are the instanceTypeIndex values for which the user is a super admin.
                if (
                    response.response?.isSysAdmin &&
                    response.response?.license.isValid &&
                    (response.response?.license.instanceTypeIndex == 1 ||
                        response.response?.license.instanceTypeIndex == 3 ||
                        response.response?.license.instanceTypeIndex == 5 ||
                        response.response?.license.instanceTypeIndex == 7)
                ) {
                    return true;
                } else {
                    this.router.navigate(['/401']);
                    return false;
                }
            })
        );
    }
}
